import React, { useContext } from 'react';
import classnames from 'classnames';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import { useDeviationViewContext } from '../../Context';
import SubscriptionLockLitFTUE from '../../Tier/ftue/SubscriptionLockLitFTUE';
import StageContainer from '../_partials/StageContainer';
import StashPaddles from '../_partials/StashPaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../Duperbrowse/redux/selectors';
import s from './DesktopTextualArtStage.scss';
const DesktopTextualArtStage = ({ deviation, className })=>{
    const { isFullscreen, isTheater } = useDeviationViewContext();
    const isDuperbrowseActive = useSelector(getIsDuperbrowseActive);
    const isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    if (isFullscreen) {
        return /*#__PURE__*/ React.createElement(StageContainer, {
            className: classnames(s['root'], s['fullscreen'], className)
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['scroll-content-wrap']
        }, /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(DeviationFullView, {
            deviation: deviation
        })), (deviation.isPublished || isDuperbrowseActive) && /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
            className: s['duperbrowse']
        }), !deviation.isPublished && !isDuperbrowseActive && /*#__PURE__*/ React.createElement(StashPaddles, null), /*#__PURE__*/ React.createElement("div", {
            className: s['fade']
        }));
    }
    return /*#__PURE__*/ React.createElement(StageContainer, {
        className: classnames(s['root'], isTheater && s['theater'], className)
    }, /*#__PURE__*/ React.createElement(DeviationFullView, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['stage-box']
    }, (deviation.isPublished || isDuperbrowseActive) && /*#__PURE__*/ React.createElement(DuperbrowsePaddles, {
        className: s['duperbrowse']
    }), !deviation.isPublished && !isDuperbrowseActive && /*#__PURE__*/ React.createElement(StashPaddles, null)), /*#__PURE__*/ React.createElement(SubscriptionLockLitFTUE, {
        deviation: deviation
    }), isSubscriptionPurchaseFTUEBeingShown && /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUE, null));
};
DesktopTextualArtStage.displayName = 'DesktopTextualArtStage';
export default DesktopTextualArtStage;

//# sourceMappingURL=DesktopTextualArtStage.js.map